<div class="container" *ngIf="isVisible">
    <div class="time-display">
        <span class="type">{{ timeType }}</span>
        <span class="time">{{ getFormattedTime() }}</span>
    </div>
    <div class="counter" 
        [class.ok]="!counterOvertime"
        [class.overtime]="counterOvertime">
        <span>{{ counter }}</span>
    </div>
</div>